import React from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  container: {
    minHeight: '100vh',
    width: '100%',
    display: 'flex',
    alignItems: 'stretch',
    flexDirection: 'column',
    background: '#f0e6d3',
  },
});

function Wrapper({ children }) {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      {children}
    </div>
  );
}

export default Wrapper;
